/* ****
  name: 工具文件
  author: alisa
  time: 2018.5
***** */
import Cookies from 'js-cookie'

// 添加事件
export function addEvent (obj, type, callback) {
  if (obj.addEventListener) {
    obj.addEventListener(type, callback, false)
  } else {
    obj.attachEvent('on' + type, callback)
  }
}
// 判断是否有class
export function hasClass (el, className) {
  let reg = new RegExp('(^|\\s)' + className + '(\\s|$)')
  return reg.test(el.className)
}

// 添加class
export function addClass (el, className) {
  if (hasClass(el, className)) {
    return
  }
  let newClass = el.className.split(' ')
  newClass.push(className)
  el.className = newClass.join(' ')
}

// 移除class
export function removeClass (el, cName) {
  if (hasClass(el, cName)) {
    el.className = el.className.replace(new RegExp('(\\s|^)' + cName + '(\\s|$)'), '')
  }
}

// 获得时间戳
export function getTimeStamp () {
  return Date.now()
}

// 埋点替换参数
export function changeParams (obj, param, value) {
  if (obj.indexOf(param) > -1) {
    const REG = `(?<=${param}=).*?(?=&)`
    const REG2 = `(?<=${param}=).*`
    let reg = new RegExp(REG)
    let reg2 = new RegExp(REG2)
    if (obj.match(reg)) {
      return obj.replace(reg, value)
    } else {
      return obj.replace(reg2, value)
    }
  } else {
    if (obj.indexOf('?') > -1) {
      return obj + '&' + param + '=' + value
    } else {
      return obj + '?' + param + '=' + value
    }
  }
}

// 获得cookie
export function getCookie (name) {
  return Cookies.get(name) || ''
}

// 生成uuid
export function getUUid (len, radix) {
  let chars = '0123456789abcdefghijklmnopqrstuvwxyz'.split('')
  let uuid = []
  let i
  radix = radix || chars.length
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
  } else {
    let r
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16
        uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
      }
    }
  }
  return uuid.join('')
}

// 获得或设置session
export function sessionTool (methods = 'GET', key = '', value = '') {
  if (methods === 'SET' || methods === 'set') {
    sessionStorage.setItem(key, value)
    return true
  } else if (methods === 'GET' || methods === 'get') {
    return sessionStorage.getItem(key)
  }
}

// 从小到大排序
export function sortAscending (data) {
  return data.sort((a, b) => {
    return a.menu_sort > b.menu_sort
  })
}

// 从cookie中获得token
export function getTheToken (url) {
  if (url.indexOf('token=') < 0) {
    let token = Cookies.get('token') || ''
    url += (url.indexOf('?') < 0 ? '?' : '&') + `token=${token}`
    return url
  } else {
    return url
  }
}

// 处理菜单数据
export function dealMenuData (d, m, id) {
  let data = d || []
  let menuCls = m || 'fixed'
  let class1 = []
  // 筛选第一级菜单
  for (let item of data) {
    item.children = []
    if (item.menu_level === '1') {
      item.children = []
      class1.push(item)
    }
  }

  if (menuCls === 'fixed') {
    // 返回第一级菜单
    return sortAscending(class1)
  } else if (menuCls === 'slider') {
    // 筛选slider菜单
    let c1id = id === '' ? class1[0].mid : id
    let allMenu = []
    /*  *****
       以下对2，3，4，5级进行分级，
       把数据分成多级对象数组
       children中存放子集菜单
    ******* */
    for (let item of data) {
      if (item.menu_level === '2' && item.menu_parent_id === c1id) {
        allMenu.push(item)
      }
    }
    for (let item of data) {
      if (item.menu_level === '3') {
        for (let menu of allMenu) {
          if (menu.mid === item.menu_parent_id) {
            menu.children.push(item)
          }
        }
      }
    }
    for (let item of data) {
      if (item.menu_level === '4') {
        for (let menu of allMenu) {
          for (let c4 of menu.children) {
            if (c4.mid === item.menu_parent_id) {
              c4.children.push(item)
            }
          }
        }
      }
    }
    for (let item of data) {
      if (item.menu_level === '5') {
        for (let menu of allMenu) {
          for (let c4 of menu.children) {
            for (let c5 of c4.children) {
              if (c5.mid === item.menu_parent_id) {
                c5.children.push(item)
              }
            }
          }
        }
      }
    }
    return allMenu
  }
}



// WEBPACK FOOTER //
// ./src/utils/util.js